import { z } from "zod";

export const equipmentScheme = z.object({
  equipment: z.array(
    z.object({
      id: z.string(),
      count: z.number(),
      range: z.number(),
      pricePerUnit: z.number(),
      isFixedPrice: z.boolean().optional().default(false),
    }),
  ),
});

export type EquipmentFormScheme = z.infer<typeof equipmentScheme>;
